import { Flex, Text } from '@mantine/core';
import { StepItemDetail } from './StepItem';
import { StepDataType } from './stepTypes';
import { useTranslation } from 'react-i18next';

type TaskStepperStepProps = {
  step: StepDataType;
  isSmallScreen: boolean;
  currentStep: number;
  currentAction: JSX.Element;
};

export const TaskStepperStep = ({
  step,
  isSmallScreen,
  currentStep,
  currentAction,
}: TaskStepperStepProps) => {
  const { t } = useTranslation('waiting-screen');

  return (
    <>
      <Flex gap="10px" wrap="wrap">
        <img
          src={step.img}
          alt=""
          aria-hidden={true}
          style={{
            margin: '0px 10px',
            minWidth: '120px',
            maxWidth: isSmallScreen ? '120px' : '250px',
          }}
        />
        <StepItemDetail
          title_long={step.title_long}
          description_long={step.description_long}
          action={step.action}
          stepNumber={currentStep}
          bottomAction={currentAction}
        />
      </Flex>
      <Text fw="700" m="40px 0px 20px 0px" size="21px" lh="24px">
        {t('Overview')}
      </Text>
    </>
  );
};
